<template>
    <iframe
        id="ytplayer"
        :src="url"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen
        style="display:block; width:100vw;min-height: 100vh;"
      ></iframe>
  </template>
  <script>

  export default {
      data(){
        return {
          url:'https://www.youtube.com/embed/Uomi_ffmL5Q?autoplay=1&mute=1'
        }
      },
      mounted(){
          if(window.location.pathname=='/presentation-video'){
                  setTimeout(()=>{
                      window.Tawk_API.hideWidget();
                  });
                  setTimeout(()=>{
                      if(_.has(window.Tawk_API,'hideWidget'))
                          window.Tawk_API.hideWidget();
                  },500)
                  setTimeout(()=>{
                      if(_.has(window.Tawk_API,'hideWidget'))
                          window.Tawk_API.hideWidget();
                  },1000)
          }
      }
  };
  </script>
